/*
errorTypes.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { MFDApp } from "./MFDApp.const";

export const errorTypes = {
  scanError: {
    code: "FM_009",
    name: "A scan error has occurred.",
    titleKey: "ERROR.SCAN_ERROR",
    keys: ["ERROR.TRY_SCANNING_AGAIN", "ERROR.IF_PROBLEM_PERSISTS_CONTACT_XEROX"],
  },
  appUnavailable: {
    titleKey: "ERROR.APP_UNAVAILABLE",
    keys: [
      "ERROR.GENERIC_ERROR_DESCRIPTION"
    ],
    exitApp: true,
    autoclose:true,
    status: 500
  },
  networkUnavailable: {
    titleKey: "ERROR.ERROR_HAS_OCCURRED",
    keys: ["ERROR.PLEASE_TRY_AGAIN", "ERROR.IF_PROBLEM_PERSISTS_CONTACT_XEROX"],
    backToMain: true,
    status: 404
  },
  errorHasOccured: {
    titleKey: "ERROR.ERROR_HAS_OCCURRED",
    keys: ["ERROR.PLEASE_TRY_AGAIN", "ERROR.IF_PROBLEM_PERSISTS_CONTACT_XEROX"],
    exitApp: true
  },
  scanSizeLimitExceed: {
    titleKey: "ERROR.SCAN_FILE_SIZE_EXCEEDS_LIMIT",
    keys: [{key:"ERROR.MAXIMUM_FILE_SIZE_IS", variables:{maxSize: MFDApp.maxUploadSize_MB}}, "ERROR.REDUCE_PAGES_AND_TRY_AGAIN"],
    backToMain: true,
    status: 413,
    autoclose: true
  },
  errorOccuredDuringProcessing: {
    titleKey: "ERROR.PROCESSING_ERROR",
    keys: ["ERROR.TRY_AGAIN"],
    backToMain: true,
    status: 550,
    autoclose: true
  },
  emailFailed: {
    titleKey: "ERROR.EMAIL_ERROR",
    keys: ["ERROR.EMAIL_NOT_SENT", "ERROR.TRY_AGAIN"],
    backToMain: true,
    status: 555,
    autoclose: true
  },
  apiKeyError: {
    titleKey: "ERROR.API_KEY_ERROR",
  keys: ["ERROR.IF_PROBLEM_PERSISTS_CONTACT_XEROX"],
    exitApp: true,
    autoclose:true
  },
  ecommerceError: {
    titleKey: "ERROR.ECOMMERCE_ERROR_TITLE",
    keys: [
      "ERROR.GENERIC_ERROR_DESCRIPTION"
    ],
    exitApp: true,
    autoclose:true
  },
  ecommerceTimeout: {
     titleKey: "ERROR.ECOMMERCE_TIMEOUT_TITLE",
    keys: [
      "ERROR.GENERIC_ERROR_DESCRIPTION"
    ],
    exitApp: true,
    autoclose:true
  },
  apiError: {
     titleKey: "ERROR.API_ERROR_TITLE",
    keys: [
      "ERROR.GENERIC_ERROR_DESCRIPTION"
    ],
    exitApp: true,
    autoclose:true
  },
    presetsError: {
     titleKey: "ERROR.PRESETS_ERROR_TITLE",
    keys: [
      "ERROR.GENERIC_ERROR_DESCRIPTION"
    ],
    exitApp: true,
    autoclose:true
  },
  maintenanceModeError: {
    titleKey: "ERROR.INSTALLING_APP_UPDATES",
    keys: ["ERROR.THIS_MAY_TAKE_SEVERAL_MINUTES", "ERROR.CLOSE_ALERT_CONTINUE_WORKING"]
  },
  redactionError: {
     titleKey: "ERROR.REDACTION_ERROR_TITLE",
    keys: [
      "ERROR.GENERIC_ERROR_DESCRIPTION"
    ],
    exitApp: false,
    autoclose:false,
    code: "F002"
  },
  redactionRequestError: {
     titleKey: "ERROR.REDACTION_REQUEST_ERROR_TITLE",
    keys: [
      "ERROR.GENERIC_ERROR_DESCRIPTION"
    ],
    exitApp: false,
    autoclose:false,
    code: "F001"
  },
  jobInfoError: {
      titleKey: "ERROR.JOB_INFO_ERROR_TITLE",
    keys: [
      "ERROR.JOB_INFO_ERROR_DESCRIPTION"
    ],
    exitApp: true,
    autoclose:true
  }
}